import { Injectable } from '@angular/core';
import { SettingsLoaderService } from '@cupoui/core/services/settings.loader.service';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  constructor(private settingsLoaderService: SettingsLoaderService) {}

  getApp(): string {
    return this.settingsLoaderService.configuration.app;
  }

  getCupouiEndpoint(): string {
    return this.settingsLoaderService.configuration.cupouiEndpoint;
  }

  isProduction(): boolean {
    return this.settingsLoaderService.configuration.isProduction;
  }

  isTest(): boolean {
    return this.settingsLoaderService.configuration.isTest;
  }

  isLocal(): boolean {
    return !this.isProduction() && !this.isTest();
  }

  getGoogleAPIKey() : string {
    return this.settingsLoaderService.configuration.googleAPIKey;
  }

  getTableauEndpoint(): string {
    return this.settingsLoaderService.configuration.tableauEndpoint;
  }

  getKeycloakSettings() {
    return this.settingsLoaderService.configuration.keycloak;
  }
}
